// Module
var code = "<react-component name=\"EventQrCodePrintPreview\"></react-component>\n";
// Exports
module.exports = code;